import { useState } from "react";
import { PaziaModal } from "components/molecules";
import { PaziaButton } from "components/atoms";
import { ModalHeader } from "../../components/templates/Modals/ModalHeader";
import { ModalPadding } from "../../components/templates/Modals/ModalPadding";
import { useBulkGenerateTrainerAccount } from "api/hooks";
import { useToaster } from "utils/toaster";
import { BulkTrainerActionResultApi } from "api/trainers/trainerAccountApi";
import { BulkTrainerActionResultSummary } from "./BulkTrainerActionResultSummary";

interface BulkGenerateTrainerAccountModalProps {
  isOpen: boolean;
  onCloseRequest: () => void;
  selectedTrainerIds: number[];
  onSuccess: () => void;
}

export const BulkGenerateTrainerAccountModal = ({
  isOpen,
  onCloseRequest,
  selectedTrainerIds,
  onSuccess,
}: BulkGenerateTrainerAccountModalProps) => {
  const { showError } = useToaster();
  const bulkGenerateAccountMutation = useBulkGenerateTrainerAccount();
  const [result, setResult] = useState<BulkTrainerActionResultApi | null>(null);

  const handleSubmit = async () => {
    try {
      const { data } = await bulkGenerateAccountMutation.mutateAsync(selectedTrainerIds);
      setResult(data);
      onSuccess();
    } catch {
      showError("Nie udało się utworzyć kont trenerów");
    }
  };

  const handleClose = () => {
    setResult(null);
    onCloseRequest();
  };

  return (
    <PaziaModal id="bulk-generate-trainer-account-modal" isOpen={isOpen} onCloseRequest={handleClose} size="full">
      <ModalPadding>
        {result ? (
          <BulkTrainerActionResultSummary
            result={result}
            successVerb="Utworzono konto"
            totalLabel="trenerów"
            onClose={handleClose}
          />
        ) : (
          <>
            <ModalHeader>Utwórz konto ({selectedTrainerIds.length} trenerów)</ModalHeader>
            <div className="mt-4 text-sm text-slate-600 dark:text-slate-300">
              Konto zostanie utworzone dla zaznaczonych trenerów, którzy nie mają go jeszcze i mają uzupełniony adres
              e-mail. Pozostali zostaną pominięci, a po zakończeniu zobaczysz podsumowanie.
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <PaziaButton type="secondary" onClick={handleClose} disabled={bulkGenerateAccountMutation.isPending}>
                Anuluj
              </PaziaButton>
              <PaziaButton
                type="primary"
                onClick={handleSubmit}
                disabled={selectedTrainerIds.length < 1 || bulkGenerateAccountMutation.isPending}
                processing={bulkGenerateAccountMutation.isPending}
              >
                Utwórz konta
              </PaziaButton>
            </div>
          </>
        )}
      </ModalPadding>
    </PaziaModal>
  );
};
